import { ACTION_TYPES } from "../actions/campaign";

const initialState = {
    campaigns: [],
    metaCampaign: {},
    analytics: {}
}

export const campaign = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CAMPAIGN_FETCH_ALL:
            return {
                ...state,
                campaigns: [...action.payload]
            }
        case ACTION_TYPES.CAMPAIGN_CREATE:
            return {
                ...state,
                campaigns: [...state.campaigns, action.payload]
            }
        case ACTION_TYPES.CAMPAIGN_UPDATE:
            return {
                ...state,
                campaigns: state.campaigns.map(x => x.id === action.payload.id ? action.payload : x)
            }
        case ACTION_TYPES.CAMPAIGN_DELETE:
            return {
                ...state,
                campaigns:state.campaigns.filter(x => x.id !== action.payload)
            }
        case ACTION_TYPES.CAMPAIGN_PAGINATION:
         
            return {
                ...state,
                campaigns: [...action.payload.campaigns],
                metaCampaign: action.payload.meta
            }
            case ACTION_TYPES.CAMPAIGN_FETCH_ANALYTICS:
                return {
                    ...state,
                    analytics: action.payload
                }
        default:
            return state;
    }
}